import { ColaboradoresProjeto } from './colaboradores-projeto';
import { ComposicaoRhProjeto } from './composicao-rh-projeto';
import { ContasCentrosCusto } from './contas-centros-custo';
import { Iniciativa } from './iniciativa';
import { MateriaisProjeto } from './materiais-projeto';
import { ParceriasProjeto } from './parcerias-projeto';
import { Unidade } from './unidade';

export class Projeto {

	id: number;
	nome: string;
	descricao: string;
	codigoProjeto: string;
	restricao:boolean;
	dataFim: Date;
	dataInicio: Date;
	dataPrevisaoInicio: Date;
	dataPrevisaoTermino: Date;
	iniciativa: Iniciativa;
	programa: any;
	usuarioAlteracao: number;
	publicoAlvo:string;
	justificativa:string;
	objetivoGeral:string;
	unidades: Unidade[];
	colaboradoresProjeto:ColaboradoresProjeto[];
	parceriasProjeto:ParceriasProjeto[];
	composicaoRhProjeto:ComposicaoRhProjeto[];
	materiaisProjeto:MateriaisProjeto[]
	contasCentrosCusto:ContasCentrosCusto[];
	idCoordenador: number;
	faixaEtariaInicial: number;
	faixaEtariaFinal: number;
	objetivoEspecifico: string;
}

